/**
 * 环境检测工具函数
 */

/**
 * 检测当前页面是否运行在 iframe 中
 * @returns {boolean} 如果在 iframe 中返回 true，否则返回 false
 */
export function isRunningInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    // 在某些情况下，跨域的 iframe 访问 window.top 可能会抛出异常
    // 如果出现异常，说明确实在 iframe 中
    return true;
  }
}

/**
 * 检测是否应该等待 Electron preload 初始化
 * @returns {boolean} 如果需要等待返回 true，否则返回 false
 */
export function shouldWaitForElectronPreload(): boolean {
  // 在以下情况下不需要等待：
  // 1. 运行在 iframe 中
  // 2. 不存在 waitForElectron 函数
  // 3. 不在 Electron 环境中
  return !isRunningInIframe() && typeof window?.waitForElectron === 'function';
}
